// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"a3ee7e2b","377":"b4431084","719":"52fcea88"}[chunkId] + ".chunk.js";
};